import { render } from "./SubSections.vue?vue&type=template&id=b0cbc71c&scoped=true"
import script from "./SubSections.vue?vue&type=script&lang=js"
export * from "./SubSections.vue?vue&type=script&lang=js"

import "./SubSections.vue?vue&type=style&index=0&id=b0cbc71c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0cbc71c"]])

export default __exports__